export enum RefillSystems {
  GAME_MONEY = 'gamemoney',
  G2A = 'g2apay',
  SKRILL = 'skrill',
}

export enum DirectRefillSystems {
  GAME_MONEY = 'gamemoney',
}
